import { Divider } from "@mui/material"
import { TProductDelivery } from "../../../core/types/Product"
import { TSaleItemStorage } from "../../../core/types/Sale"
import CourseDeliverySection from "./CourseDeliverySection"
import TicketDeliverySection from "./TicketDeliverySection"

interface DeliveryInstructionsProps {
  items: TSaleItemStorage[]
  customerEmail: string
}

const COURSE_DELIVERIES = [
  TProductDelivery.Course,
  TProductDelivery.eBook,
  undefined,
]

const DeliveryInstructions = ({
  items,
  customerEmail,
}: DeliveryInstructionsProps) => {
  const groups = new Map<TProductDelivery | undefined, TSaleItemStorage[]>()

  items.forEach((item) => {
    if (item.delivery === TProductDelivery.Community) return

    const normalizedKey = COURSE_DELIVERIES.includes(item.delivery) ? undefined : item.delivery
    if (!groups.has(normalizedKey)) groups.set(normalizedKey, [])
    groups.get(normalizedKey)!.push(item)
  })

  const entries = Array.from(groups.entries()).filter(
    ([delivery]) => delivery === TProductDelivery.Ticket || delivery === undefined
  )

  return (
    <>
      {entries.map(([delivery, groupItems], index) => (
        <>
          {index > 0 && <Divider sx={{ my: 2 }} />}
          {delivery === TProductDelivery.Ticket ? (
            <TicketDeliverySection
              key="ticket"
              items={groupItems}
              customerEmail={customerEmail}
            />
          ) : (
            <CourseDeliverySection
              key="course"
              items={groupItems}
              customerEmail={customerEmail}
            />
          )}
        </>
      ))}
    </>
  )
}

export default DeliveryInstructions
